module.exports = __webpack_public_path__ + "img/temp_dc1.dcc4670e.jpg";